import { IFamilyMember } from '@/common/integrations/menhir/employee/employee/employee.types';
import {
  IMenhirBeneficiary,
  IMenhirReimbursableItem,
  IReimbursableItem,
} from '@/common/integrations/menhir/employee/reimbursements/reimbursements.types';

export const transformReimbursableItem = (
  item: IMenhirReimbursableItem
): IReimbursableItem => ({
  id: item.id,
  name: item.name,
  provider: item.provider,
  type: item.type,
});

export const transformReimbursableItems = (items: IMenhirReimbursableItem[]) =>
  items.map(transformReimbursableItem);

export const transformReimbursementBeneficiary = (
  beneficiary: IMenhirBeneficiary
): IFamilyMember => ({
  id: beneficiary.id,
  birthdate: beneficiary.birth_date,
  taxId: beneficiary.tax_id && {
    value: beneficiary.tax_id.value,
    type: beneficiary.tax_id.type,
  },
  fullName: beneficiary.name,
  type: beneficiary.relation_type as IFamilyMember['type'],
  shortName: inferBeneficiaryShortName(beneficiary),
  files: beneficiary.files ?? [],
});

export const inferBeneficiaryShortName = (beneficiary: IMenhirBeneficiary) =>
  beneficiary.short_name ?? beneficiary.name.split(' ')[0];

export const transformReimbursementBeneficiaries = (
  items: IMenhirBeneficiary[]
) => items.map(transformReimbursementBeneficiary);
